import { Box, Card, Group, ScrollArea, Text } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import B2bTable from "components/reusable/b2bTable";
import ExportComponent from "utiles/export";
import { formatNumber } from "utiles/url";

const BussinessTable = ({ ordersList, userName, totalAmount }) => {
  const headerData = [
    {
      label: "#",
      key: "index",
      sortable: false,
      searchable: false,
      width: "5%",
      render: (_rowData, rowIndex) => <span>{rowIndex + 1}</span>,
    },
    {
      label: "Businesses Name",
      key: "business_name",
      sortable: false,
      searchable: true,
      render: (rowData) => <b>{rowData?.business_name}</b>,
    },
    {
      label: "Businesses Phone",
      key: "business_phone",
      sortable: false,
      searchable: true,
      render: (rowData) => <span>{rowData?.business_phone_number}</span>,
    },
    {
      label: "Total Commission",
      key: "total_commission",
      sortable: false,
      searchable: false,
      render: (rowData) => (
        <span>{formatNumber(rowData.total_commission)}</span>
      ),
    },
    {
      label: "Date",
      key: "created_at",
      sortable: true,
      searchable: false,
      render: (rowData) => (
        <span>
          {new Date(rowData.created_at).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })}
        </span>
      ),
    },
  ];

  const { height } = useViewportSize();
  const computedTotal =
    totalAmount ??
    (ordersList || []).reduce(
      (sum, row) => sum + (row.total_commission || 0),
      0,
    );

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <Group position="apart" align="center" mb="sm" px="xs">
        <Box>
          {userName && (
            <Text weight={700} size="lg">
              {userName}
            </Text>
          )}
          <Text weight={600} size="md" color="dimmed">
            Transactions
          </Text>
        </Box>
        <ExportComponent
          data={ordersList || []}
          headers={headerData}
          reportTitle="Business Commission Transactions Detail"
          fileNamePrefix={`business_${userName || "detail"}_transactions`}
          userName={userName}
          totalAmount={formatNumber(computedTotal)}
        />
      </Group>

      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <Card shadow="sm" p="lg">
          <ScrollArea>
            <B2bTable
              header={headerData}
              data={ordersList || []}
              layout={{ minWidth: 700 }}
              total={1}
              searchInput={false}
              activePage={1}
              loading={false}
            />
          </ScrollArea>
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "12px",
              paddingRight: "8px",
            }}
          >
            <Text weight={700} size="sm">
              Total Amount: {formatNumber(computedTotal)}
            </Text>
          </Box>
        </Card>
      </ScrollArea>
    </div>
  );
};

export default BussinessTable;
